module.exports = __webpack_public_path__ + "a8d786e75a09e04f692d60dc29fefe2d.svg";